import firebase from 'firebase'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AddPackage from '../views/AddPackage.vue'
import Packs from '../views/Packs.vue'
import Login from '../views/Login.vue'
import Terms from '../views/Terms.vue'
import Privacy from '../views/Privacy.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/dashboard',
    redirect: '/dashboard/packs'
  },
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/dashboard/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/dashboard/add-pack/:id?',
    name: 'add-package',
    component: AddPackage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dashboard/packs',
    name: 'packs',
    component: Packs,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy
  },
]

const router = new VueRouter({
  mode: 'history',
  routes: routes,
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) next('/dashboard/login')
  else next()
})

export default router
